import React from 'react';

import { cn } from '../../lib/utils';

import SettingsBackArrowIcon from '../../../assets/images/settings-back-arrow.svg';

const MobileBackButton = ({ onClick, className = '' }) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'flex size-12 flex-shrink-0 items-center justify-center rounded-full border border-white bg-white/30 settings-button-shadow backdrop-blur-md dark:border-white/5 dark:bg-neutral-900/80 dark:backdrop-blur',
      className,
    )}
  >
    <SettingsBackArrowIcon className="size-5 text-gray-600 dark:text-white" />
  </button>
);

export default MobileBackButton;
